import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd"
import DropdownOptionRow from "./DropdownOptionRow"
import PropTypes from "prop-types"
import { reOrder } from "utils/arrays"

const rowStyles = {
  first: { borderRadius: "4px 4px 0 0", borderTop: "1px solid var(--pane--border-color)" },
  last: { borderRadius: "0 0 4px 4px" }
}

// NOTE: Previously this UI was rendered using a table. However, the combination of table
//   elements and react-beautiful-dnd prevented us from editing an option inline. This
//   custom component using css grid layout allows us to have draggable and editable rows.
const DraggableOptionList = ({
  options,
  onOptionsReorder,
  editingRow,
  onUpdateChoice,
  onRowClick,
  onRemoveChoice
}) => {
  const handleDragEnd = ({ source, destination }) => {
    if (!destination || destination.index === source.index) return
    const newOptions = reOrder(options, source.index, destination.index)
    onOptionsReorder(newOptions.map(option => ({ choice: option })))
  }

  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <Droppable droppableId="droppable">
        {(provided, _) => (
          <div ref={provided.innerRef} {...provided.droppableProps}>
            {options.map((option, i) => (
              <Draggable key={i} draggableId={`draggable-option-${i}`} index={i}>
                {(provided, _) => (
                  <DropdownOptionRow
                    rowStyle={
                      i === 0 ? rowStyles.first : i === options.length - 1 ? rowStyles.last : {}
                    }
                    innerRef={provided.innerRef}
                    draggableProps={provided.draggableProps}
                    dragHandleProps={provided.dragHandleProps}
                    option={option}
                    isEditing={editingRow === i}
                    onUpdateChoice={onUpdateChoice}
                    onRemoveChoice={onRemoveChoice}
                    index={i}
                    onClick={() => onRowClick({ id: i })}
                  />
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  )
}

DraggableOptionList.propTypes = {
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  onOptionsReorder: PropTypes.func.isRequired,
  editingRow: PropTypes.number,
  onUpdateChoice: PropTypes.func.isRequired,
  onRowClick: PropTypes.func.isRequired,
  onRemoveChoice: PropTypes.func.isRequired
}

export default DraggableOptionList
